var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBellLinear2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.415 18.548c.631 0 1.025.683.708 1.229a2.454 2.454 0 0 1-4.246 0 .818.818 0 0 1 .708-1.229h2.83zM19.22 2.01a.7.7 0 0 1 .99.99L3.7 19.51a.7.7 0 0 1-.99-.99zm-1.428 4.512.028.034.023.038a6.52 6.52 0 0 1 .702 2.953v4.091c0 .904.733 1.637 1.637 1.637 1.09 0 1.09 1.636 0 1.636H8.164a.48.48 0 0 1-.34-.818l.526-.525a1 1 0 0 1 .707-.293h8.29a3.259 3.259 0 0 1-.438-1.637V9.547c0-.485-.07-.954-.201-1.396l-.086-.263a.731.731 0 0 1 .171-.763l.603-.603a.28.28 0 0 1 .396 0zM12 3c1.09 0 2.118.267 3.022.738.105.055.227.126.367.215a.686.686 0 0 1 .117 1.065l-.028.028a1 1 0 0 1-1.194.166 4.12 4.12 0 0 0-.45-.221A4.91 4.91 0 0 0 7.09 9.547v3.472a1 1 0 0 1-.293.707l-3.01 3.01a.35.35 0 0 1-.367.08l-.073-.036c-.588-.388-.431-1.505.47-1.505.904 0 1.637-.733 1.637-1.637V9.547A6.546 6.546 0 0 1 12 3z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8F9BB3",
    xlinkHref: "#a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellLinear2);
export default __webpack_public_path__ + "static/media/icon-bell-linear-2.527bfe64.svg";
export { ForwardRef as ReactComponent };